// tslint:disable
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// tslint:enable

import { Component, Input } from '@angular/core';
import { AuthState } from 'aws-amplify-angular/dist/src/providers/auth.state';
import { AmplifyService } from 'aws-amplify-angular';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { PasswordStrengthValidator } from '../../validators/passwordStrength';
import { CustomValidators } from 'ngx-custom-validators';

@Component({
  selector: 'app-amplify-auth-forgot-password-core',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  // tslint:disable-next-line:variable-name
  _authState: AuthState;
  // tslint:disable-next-line:variable-name
  _show: boolean;

  username: string;
  code: string;
  password: string;

  userData = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  formData: FormGroup;

  errorMessage: string;

  // tslint:disable-next-line:variable-name
  code_sent = false;

  amplifyService: AmplifyService;

  constructor(amplifyService: AmplifyService) {
    this.amplifyService = amplifyService;
    const password = new FormControl('', [Validators.required, Validators.minLength(8), PasswordStrengthValidator]);
    const certainPassword = new FormControl('', CustomValidators.equalTo(password));
    this.formData = new FormGroup({
      code: new FormControl('', Validators.required),
      newPass: password,
      newPassCheck: certainPassword,
    });
  }

  @Input()
  set data(data: any) {
    this._authState = data.authState;
    this.userData.controls.email.setValue(data.authState.user ? data.authState.user.username || '' : '');
  }

  @Input()
  set authState(authState: AuthState) {
    this._authState = authState;
    this._show = authState.state === 'forgotPassword';

    this.userData.controls.email.setValue(authState.user ? authState.user.username || '' : '');
  }

  setUsername(username: string) {
    this.username = username;
  }

  isValid() {
    return this.formData.valid;
  }

  isEmailValid() {
    return this.userData.valid;
  }

  setCode(code: string) {
    this.code = code;
  }

  setPassword(password: string) {
    this.password = password;
  }

  onSend() {
    const { email } = this.userData.getRawValue();
    if (!email) {
      this.errorMessage = 'Email cannot be empty';
      return;
    }
    this.amplifyService
      .auth()
      .forgotPassword(email)
      .then(() => {
        this.code_sent = true;
      })
      .catch(err => {
        this._setError(err);
        this.code_sent = false;
      });
  }

  onSubmit() {
    const { email } = this.userData.getRawValue();
    const { code, newPass } = this.formData.getRawValue();
    this.amplifyService
      .auth()
      .forgotPasswordSubmit(email, code, newPass)
      .then(() => {
        const user = { username: email };
        this.amplifyService.setAuthState({ state: 'signIn', user });
      })
      .catch(err => this._setError(err));
  }

  onSignIn() {
    this.amplifyService.setAuthState({ state: 'signIn', user: null });
  }

  onAlertClose() {
    this._setError(null);
  }

  _setError(err) {
    if (!err) {
      this.errorMessage = null;
      return;
    }

    this.errorMessage = err.message || err;
  }
}
